<div class="page-wrapper">
  <svg-icon preserveAspectRatio="none" [src]="svgIconPath" [stretch]="true"></svg-icon>
  <div class="page-header">{{ buildTranslationKey(pageHeader) | translate }}</div>
  @if (pageDescription) {
    <div class="page-description">
      {{ pageDescription }}
    </div>
  }
</div>
